module.exports = __webpack_public_path__ + "img/学校@0.5x.1853f7d7.png";